export default {
    disclaimer: {
        label_default: "Reconheço e concordo que os itens que estou encomendando/recebendo são propriedade da O-I para serem usados em atividades relacionadas ao trabalho da O-I e, como tal, a O-I reserva-se o direito de solicitar a devolução da propriedade após minha saída da O-I (ou antes, se exigido pela O-I).",
        label_type_1: "Confirmo que a autoavaliação para trabalho remoto foi preenchida com precisão e de boa-fé, e que qualquer equipamento ou mobiliário fornecido pela O-I ou encomendado através da Gear será utilizado por mim para fins de trabalho na O-I. Reconheço e concordo que os itens que estou encomendando/recebendo são propriedade da O-I e devem ser utilizados para atividades relacionadas ao trabalho na O-I. Portanto, a O-I reserva-se o direito de solicitar a devolução dos itens após meu desligamento da O-I (ou antes, se exigido pela O-I).",
        errors: {
            required: "Por favor, aceite os termos de uso"
        }
    },
    cost_center: {
        label: "Código do Centro de Custo",
        placeholder: "Código do Centro de Custo",
        cost_center_not_found: "Os centros de custo que não estiverem presentes podem levar até 24 horas para aparecer. Entre em contato com a Central de Atendimento Global caso não encontre o centro de custo desejado.",
        errors: {
            regex: "Código de centro de custos inválido"
        }
    },
    company_code: {
        label: "Código da empresa"
    },
    cost_center_name: {
        label: "Nome do Centro de Custos"
    },
    order_note: {
        label: "Nota do pedido",
        placeholder: "Nota opcional para aprovação do gerente",
    },
    send_emails_to_oobo_orderer: {
        "OOBO": "Avise-me sobre as atualizações deste pedido"
    },
    "dell_banner":{
        label: "Devido a atualizações de sistema da Dell, os pedidos feitos entre 1º e 14 de agosto de 2026 podem sofrer atrasos significativos no processamento. Por favor, considere prazos de entrega mais longos durante esse período. Agradecemos a sua compreensão."
    }
}